export interface Promiseable {
    do (): any
    checker(): boolean
    resolve (data: any): void
    reject (): void
}

export const retryWithTimeout = (action: Promiseable, interval: number, retryCount: number) => {
  if (retryCount <= 0) {
    action.reject()
    return
  }
  if (!action.checker()) {
    setTimeout(() => {
      retryCount -= 1
      retryWithTimeout(action, interval, retryCount)
    }, interval)
    return
  }

  action.resolve(action.do())
}
